import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AutoDeleteSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AutoDeleteSVG;
